<div class="controls-bottom" [class.sidebar-open]="viewState.ttms">
    @if (selectedTtm) {
        <div *ngIf="!mobileControls || movingEntity"
             [class.disabled]="!movingEntity || savingMove || cancelingMove"
             (click)="undoMove()"
             matTooltip="Ongedaan maken"
             matTooltipPosition="above">
            <i class="fa fa-undo" *ngIf="!cancelingMove"></i>
            <i class="fa fa-spinner fa-spin" *ngIf="cancelingMove"></i>
        </div>
        @if (!mobileControls || !movingEntity) {
            @if (movingTtm && !movePoints) {
                <div [class.downlight]="!movingKeepGnd"
                     (click)="movingKeepGnd=!movingKeepGnd"
                     [matTooltip]="movingKeepGnd ? 'Grondlocatie vasthouden' : 'Grondlocatie ook verplaatsen'"
                     matTooltipPosition="above">
                    <i class="fa fa-map-location"></i>
                </div>
            } @else {
                <div [class.active]="!movingTtm && movingEntity && !movePoints"
                     [class.highlight]="!movingEntity"
                     [class.disabled]="(movingEntity && movePoints) || !ttmMoveAllowed"
                     (click)="ttmMove()"
                     matTooltip="Wijzig locatie"
                     matTooltipPosition="above">
                    <i class="fa fa-map-location"></i>
                </div>
            }
            <div [class.active]="movingTtm"
                 [class.disabled]="movingEntity && movePoints"
                 (click)="ttmMoveTotal()"
                 matTooltip="Verplaats maatregel"
                 matTooltipPosition="above">
                <i class="fa fa-arrows-up-down-left-right"></i>
            </div>
            <div [class.disabled]="(movingEntity && !movePoints) || !selectedTtm?.entities[0]?.line"
                 [class.active]="movePoints"
                 (click)="ttmMoveFree()"
                 class="d-none d-md-block"
                 matTooltip="Tekenen"
                 matTooltipPosition="above">
                <i class="fa fa-pen"></i>
            </div>
            <div [class.disabled]="movingEntity"
                 (click)="mergeTtms()"
                 *ngIf="mergeTtms"
                 matTooltip="Samenvoegen"
                 matTooltipPosition="above">
                <i class="fa fa-merge"></i>
            </div>
            <div [class.disabled]="movingEntity || !(selectedTtm?.entities?.length > 1)"
                 (click)="splitTtm()"
                 *ngIf="splitTtm"
                 matTooltip="Splitsen"
                 matTooltipPosition="above">
                <i class="fa fa-split"></i>
            </div>
            <div (click)="navigate()"
                 matTooltip="Navigeer"
                 matTooltipPosition="above">
                <i class="fa fa-location-arrow"></i>
            </div>
        }

        <div *ngIf="!mobileControls || movingEntity"
             [class.disabled]="!movingEntity || savingMove || cancelingMove"
             (click)="saveMove()"
             matTooltip="Opslaan"
             matTooltipPosition="above">
            <i class="fa fa-save" *ngIf="!savingMove"></i>
            <i class="fa fa-spinner fa-spin" *ngIf="savingMove"></i>
        </div>
    }

    <div [class.active]="addingTtm"
         [class.disabled]="savingNewTtm || !(selectedDrawingIds?.length)"
         (click)="startAddTtm()"
         matTooltip="Nieuwe maatregel toevoegen"
         matTooltipPosition="above">
        @if (!savingNewTtm){
            @if (addingTtm){
                <i class="fa fa-close"></i>
            } @else {
                <i class="fa fa-plus"></i>
            }

        } @else {
            <i class="fa fa-spinner fa-spin" *ngIf="savingNewTtm"></i>
        }
    </div>
</div>

@if (addingTtm && placementPosition && (Features.TtmsAddSave | hasFeature)) {
    <map-advanced-marker
        [zIndex]="1000"
        [position]="placementPosition"
        (mapClick)="onPlacementMarkerClick($event)"
        [content]="null | customMarker"></map-advanced-marker>
}

@for (movePoint of movePoints; track $index) {
    <map-advanced-marker
        [zIndex]="999"
        [gmpDraggable]="true"
        (mapClick)="removePoint(movePoint)"
        (mapDragend)="updatePoint(movePoint, $event)"
        [position]="movePoint"></map-advanced-marker>
}
